module.exports = "mat-form-field {\n  margin-left: 10px; }\n\nmat-checkbox {\n  margin-left: 10px; }\n"